<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, useSlots, computed } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import LinhaDaTabela from './LinhaDaTabela/LinhaDaTabela.vue';
import UtilArray from '@/utils/UtilArray.mjs';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const slots = useSlots();

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('linha-item.'))

);

/*==================================================================*/
/*================== VALIDA DADOS VAZIOS ===========================*/
/*==================================================================*/

const dadosVazios = computed(() => {

    return UtilArray.isEmpty(props.dados);

});

</script>

<template>

    <div class="c-tabela__body">

        <div v-if="dadosVazios" class="c-tabela__linha--vazia">
            Nenhum dado encontrado.
        </div>

        <LinhaDaTabela
            v-else
            v-for="dado in props.dados"
            :key="dado?.id"
            :headers="props.headers"
            :dado="dado"
            :disabled="props.disabled"
        >

            <template #linha-botoes="slotProps">

                <slot name="linha-botoes" v-bind="slotProps"></slot>

            </template>

            <template
                v-for="name in slotsDeItem"
                #[name]="slotProps"
            >

                <slot :name="name" v-bind="slotProps ?? {}"></slot>

            </template>

        </LinhaDaTabela>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== Body da Tabela ================================*/
/*==================================================================*/

.c-tabela__body {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

/*==================================================================*/
/*================== Estado Vazio ==================================*/
/*==================================================================*/

.c-tabela__linha--vazia {
    grid-column: 1 / -1;
    padding: 16px;
    text-align: center;
    color: #999;
    font-size: 0.875rem;
}

</style>
